import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { store as StoreInformationApi } from '@teem/constants/api';
import { country as CountryApi } from '@teem/core/constants/api';
import { objectToFormData } from '@teem/helpers/functions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreInformationService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public getMyStore() {
    return this.httpClient.get(`${StoreInformationApi.getMyStore}`)
  }

  public getProductInfo() {
    return this.httpClient.get(`${StoreInformationApi.productInformation}`)
  }

  public getServiceInfo() {
    return this.httpClient.get(`${StoreInformationApi.serviceInformation}`)
  }

  public getKSACities() {
    return this.httpClient.get(`${CountryApi.cities}?limit=100`)
  }

  public getTemplateInfo() {
    return this.httpClient.get(`${StoreInformationApi.templateInformation}`)
  }

  public getBranchesInfo(){
    return this.httpClient.get(`${StoreInformationApi.branchesInfo}?limit=100`)
  }

  public editBranchInfo(branchId : any){
    return this.httpClient.get(`${StoreInformationApi.editBranch}?branch_id=${branchId}`)
  }

  public deleteBranch(branchId : any){
    return this.httpClient.post(`${StoreInformationApi.deleteBranch(branchId)}`,[])
  }

   public updateBranchStatus(branchId : any,branchStatus: any){
    return this.httpClient.get(`${StoreInformationApi.updateBranchStatus}?branch_id=${branchId}&branch_status=${branchStatus}`)
  }
  

  public getCities(regionId: string) {
    if (regionId)
      return this.httpClient.get(`${CountryApi.cities}?region_id=${regionId}`)
    else
      return this.httpClient.get(`${CountryApi.cities}?limit=100`)
  }

  public getDistricts(cityId: string) {
    if (cityId)
      return this.httpClient.get(`${CountryApi.districts}?city_id=${cityId}`)
    else
      return this.httpClient.get(`${CountryApi.districts}?limit=100`)
  }

  public getDeliveryCostByDistrict(districtId: string) {
    return this.httpClient.get(`${CountryApi.delivery_cost}?district_id=${districtId}`);
  }

  public updateProductInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationApi.productInformation}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationApi.productInformation}`, params)
    }
  }

  public updateServiceInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationApi.serviceInformation}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationApi.serviceInformation}`, params)
    }
  }


  public uploadFile(formData) {
    // return this.httpClient.post(`${UserApi.uploadLogo}`, formData);
    return this.httpClient.post<any>(`${StoreInformationApi.uploadLogo}`, formData, {
      reportProgress: true,
      observe: 'events'
    });
  }

  public removeFile(type) {
    return this.httpClient.delete(`${StoreInformationApi.removeLogo(type)}`)
  }

  // public updateProductInfo(params: any, options?: any) {
  //   if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
  //     let fd = objectToFormData(params);
  //     fd.append('_method', 'put');
  //     return this.httpClient.post(`${StoreInformationsApi.productInformation}`, fd)
  //   } else {
  //     return this.httpClient.put(`${StoreInformationsApi.productInformation}`, params)
  //   }
  // }

  public updateBranchTemplateInfo(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationApi.branchTemplateInformation}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationApi.branchTemplateInformation}`, params)
    }
  }
  
  public createStoreBranch(params: any, options?: any) {
    if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
      let fd = objectToFormData(params);
      fd.append('_method', 'put');
      return this.httpClient.post(`${StoreInformationApi.createBranch}`, fd)
    } else {
      return this.httpClient.put(`${StoreInformationApi.createBranch}`, params)
    }
  }
  

  // public updateServiceInfo(params: any, options?: any) {
  //   if (options && options['headers'] && options['headers']['Content-Type'] && options['headers']['Content-Type'] == 'multipart/form-data') {
  //     let fd = objectToFormData(params);
  //     fd.append('_method', 'put');
  //     return this.httpClient.post(`${StoreInformationsApi.serviceInformation}`, fd)
  //   } else {
  //     return this.httpClient.put(`${StoreInformationsApi.serviceInformation}`, params)
  //   }
  // }

  public getFoodicsInfo() {
    return this.httpClient.get(`${StoreInformationApi.foodicsInfo}`)
  }

  public updateFoodicsProducts(params: any) {
    return this.httpClient.post(`${StoreInformationApi.updateFoodicsProducts}`, params)
  }

  public disconnectFoodics() {
    return this.httpClient.get(`${StoreInformationApi.disconnectFoodics}`)
  }

  checkSlug(params: any): Observable<any> {
    return this.httpClient.post<{ exists: boolean }>(`${StoreInformationApi.checkSlug}`, params);        
  }

  checkBranchSlug(params: any): Observable<any> {
    return this.httpClient.post<{ exists: boolean }>(`${StoreInformationApi.checkBranchSlug}`, params);        
  }

  public updateFoodicsBranch() {
    return this.httpClient.get(`${StoreInformationApi.updateFoodicsBranch}`)
  }

  public setReceivingBranch(params: any) {
    return this.httpClient.post(`${StoreInformationApi.setReceivingBranch}`, params)
  }

}
